<template>
    <div v-if="visible" class="ftu-content-box">
        <img src="@/assets/images/bundles-ftu.png" />

        <h3>{{ header }}</h3>

        <p>{{ description }}</p>

        <a data-qa="dismiss-link" class="dismiss-link" @click="dismiss">
            {{ $t('ftu.contentBox.dismiss') }}
        </a>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        header: String,
        description: String,
        feature: String,
    },

    computed: {
        ...mapState({
            viewed: ({ ftu }) => ftu.viewed,
        }),

        visible() {
            return !this.viewed[this.feature];
        },
    },

    methods: {
        dismiss() {
            this.$store.dispatch('ftu/UPDATE_FTU', this.feature);
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .ftu-content-box {
        @include card;
        color: $color-gray;
        padding: $spacing-400;
        background: $color-gray-20;
        box-shadow: none;
        display: inline-block;
        position: relative;
        width: 100%;

        @media($small) {
            width: 100%;
            display: flex;
            flex-direction: column;
        }

        img {
            width: px-to-rem(120px);
            float: left;
            margin-right: $spacing-400;

            @media($small) {
                display: block;
                margin: 0 auto $spacing-400 auto;
            }
        }

        .dismiss-link {
            position: absolute;
            bottom: 0;
            right: 0;
            margin: $spacing-200 $spacing-600 $spacing-200 $spacing-200;
        }

        h3 {
            margin-bottom: $spacing-200;
        }

        p {
            font-size: px-to-rem(18px);
        }
    }

    [dir=rtl] {
        .ftu-content-box {
            img {
                float: right;
                margin-left: $spacing-400;
            }

            .dismiss-link {
                right: auto;
                left: 0;
                margin: $spacing-200 $spacing-200 $spacing-200 $spacing-600;
            }
        }
    }
</style>
